import React from "react"
import { SelectInput } from "react-admin"
import { AttributeType } from "src/models/Attribute"

const AttributeTypeInput = (props) => {
  return <SelectInput source="type" label={"Attribute type"} name={"type"} choices={Object.keys(AttributeType).map((key) => ({ id: AttributeType[key], name: AttributeType[key] }))} {...props} />
}

export default AttributeTypeInput
